export const DS_BUTTON_GROUP_CLASSES = {
  Root: "ds-button-group",
  Option: "ds-button-group__option",
} as const;
